import ViewAssetPromotion from "./ViewAssetPromotion";

export default ViewAssetPromotion;